import { Component } from 'react';
import PropTypes from 'prop-types';
import monitoringService from '@services/monitoring';

class AuthBoundaryError extends Error {
  constructor(message, type = 'auth_boundary') {
    super(message);
    this.name = 'AuthBoundaryError';
    this.type = type;
  }
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return { 
      hasError: true,
      error 
    };
  }

  componentDidCatch(error, errorInfo) {
    monitoringService.trackException(error, {
      componentStack: errorInfo.componentStack,
      operation: 'error_boundary'
    });
  }

  render() {
    const { hasError, error } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      if (fallback) {
        return fallback(error);
      }
      return (
        <div className="flex items-center justify-center min-h-[200px] p-4 bg-red-50 rounded-lg">
          <div className="text-center">
            <h3 className="text-lg font-medium text-red-800 mb-2">
              Something went wrong
            </h3>
            <p className="text-sm text-red-600">
              {error?.message || 'An unexpected error occurred'}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func
};

export { ErrorBoundary, AuthBoundaryError };
